<template>
  <div class="iv-feedback-opinions iv-p-t-40 iv-p-b-40">
    <div class="iv-main-width iv-p-b-40">
      <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line" style="margin-bottom: 60px;"><span>{{this.title}}</span></h1>
      <div class="iv-m-t-16">
         <div class="iv-m-t-16 iv-feedback-header-left">
           <Button class="iv-m-r-8 iv-m-b-16" noIcon :type="objectNameIndex == index ? 'add': 'cancel'" shape="circle" v-for="(val, index) in opinionObject" :key="index" @click="nameClick(val, index)">{{val.objectName}}</Button>
        </div>
        <div>
           <div class="iv-m-t-16" v-for="(val, index) in opinions" :key="index">
            <div style="display: flex;" class="iv-feedback-table ivu-table-cell  iv-border-color">
               <span class="iv-pointer" style="margin-right: 85px;">{{Number(index) + 1}}</span>
               <span class="iv-pointer" >{{val.opinionContent}}</span>
            </div>
            <Table
            noUrl
            :show-header="false"
            noSearch
            ref="Table"
            :immediate="true"
            :showPage="false"
            :showSelect="false"
            :showTree="false"
            :showDelete="false"
            :showEdit="false"
            :columns="columns"
            :disabledDrag="false"
            :tableData="val.feedback"
            >
            </Table>
            <div v-if="type != 'see'" class="iv-feedback-lang-last ivu-table-cell  iv-border-color ">
               <IconFont type="file-add"></IconFont>
               <span @click="addFeedback(index)">新增意见</span>
            </div>
           </div>
        </div>
      </div>
       
      <FooterOperator>
      <div class="iv-text-center">
        <span v-if="type != 'see'">
        <Button class="iv-m-r-8" type="save" @click="onSave">保存</Button>
        <Button class="iv-m-r-8" type="submit" @click="onPublish" >提交意见</Button>
        </span>
        <Button type="back" @click="onBack">返回</Button>
      </div>
    </FooterOperator>
    </div>
  </div>
</template>

<script>
import LayoutTitle from '@/components/layout/layout-title'
import Table from '@/components/drag-table-inline'
import FooterOperator from '@/components/footer-operator'
import IconFont from '@/components/iconfont'
import columns from './columns.js'
export default {
  components: {
    Table,
    IconFont,
    FooterOperator,
    LayoutTitle
  },
  data () {
    return {
      show: false,
      opinions: [],
      opinionObject: [],
      objectNameIndex: 0,
      title: this.$route.query.title,
      type: this.$route.query.type,
      objectId: this.$route.query.objectId,
    }
  },
  provide () {
    return {
      operateClick: this.operateClick
    }
  },
  created () {
    this.getUserCollectedOpinion() //集成时需要调用接口
    this.columns = columns.call(this)
    this.opinions = this.opinionObject[this.objectNameIndex].opinions
  },
  methods: {
    getUserCollectedOpinion () {
      this.$ajax({
        url: 'api-portal/collectOpinion/getCollectedOpinion',
        method: 'GET',
        data: {
          objectId: this.objectId
        }
      }).then(data => {
        let res = data.data.data
        this.opinionObject = res.opinionObject
        this.opinions = this.opinionObject[0].opinions
        this.opinions.forEach((item,index)=>{
          item.$index = index
          item.feedback.forEach(item => {
            item.$index = index
          })
        })
        this.show = true
      })
    },
    // 人员按钮切换
    nameClick (val, index) {
      this.objectNameIndex = index
      this.opinions = this.opinionObject[index].opinions
      this.show = true
    },
    // 新增意见
    addFeedback (index) {
      this.opinions[index].feedback.push({
        content: '',
        $type: 'add',
        $isEdit: true,
        $index: index,
        opinionId: this.opinions[index].opinionId
      })
    },
    operateClick(type, item) {
      switch (type) {
        case 'delete': 
          this.opinions[item.$index].feedback.splice(item._index, 1)
          break 
      }
    },
    // 提交意见反馈
    saveUserFeedbackOpinion(isSubmit) {
      let opinions = []
      this.opinions.forEach(item => {
        item.feedback.forEach(val => {
          opinions.push({
            content: val.content,
            opinionId: item.opinionId
          }) 
        })
      })
      if(opinions.length == 0) {
        this.$Message.error('没有填写意见')
      } else {
        this.$ajax({
          url: 'api-uum/collectOpinion/saveUserFeedbackOpinion',
          method: 'POST',
          disabledData: true,
          data: {
            opinionObjectId: this.opinionObject[this.objectNameIndex].opinionObjectId,
            isSubmit: isSubmit,
            objectId: this.objectId,
            opinions: opinions
          }
        }).then(data => {
          if (isSubmit == 0) {
            this.$Message.success('保存成功')
          } else {
            this.$Message.success('反馈成功')
          }
        })
      }
    },
    onSave () {
      this.saveUserFeedbackOpinion(0)
    },
    onPublish () {
      this.saveUserFeedbackOpinion(1)
    },
    onBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.iv-feedback-opinions {
  min-height: 100%;;
  background-color: #fff;
}
.iv-feedback-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.iv-feedback-header-left, .iv-feedback-header-right {
  display: flex;
  align-items: center;
}
.iv-feedback-table {
  border: 1px solid;
  font-size: 14px;
  border-bottom: none;
  font-weight: bolder;
  background: rgba(250, 250, 250, 0.9);
}
.iv-feedback-lang-last {
  text-align: center;
  border: 1px dashed;
  border-top: none;
  margin-top: -24px;
}
</style>